export default async function saveRenderProject(renderProject) {
  // reorder layer perspective before saving
  // map from the MM model to the CF/RE model
  // MM: [ll, hl, hh, lh] => CF/RE: [ll, lh, hh, hl]
  let averagePpf = 0;
  renderProject.layers.forEach((l, index) => {
    if (l.perspective && l.perspective.points) {
      const layerPpf = window.Renoworks.Util.calculatePpf(
        l.perspective.points,
        l.physicalWidth,
        l.physicalHeight,
      );
      if (window.Renoworks.Util.isClockwise(l.perspective.points)) {
        const p1 = l.perspective.points[1];
        l.perspective.points[1] = l.perspective.points[3];
        l.perspective.points[3] = p1;
      }
      averagePpf = ((averagePpf * index) + layerPpf) / (index + 1);
    }
  });
  // sane default ppf
  if (averagePpf === 0) {
    averagePpf = 32;
  }
  // set current ppf for rendering the project(s)
  renderProject.setPpf(Math.round(averagePpf));
  return renderProject.save(); // do not use ProjectController.save, as it does more
}



// WEBPACK FOOTER //
// ./src/helpers/project.js